module.exports = __webpack_public_path__ + "fonts/IRANSansWeb.e8bf431.eot";